<ng-template #content let-modal>
  <div class="modal-body-terms" id="top">
    <div id="top-doc" class="content-term">
      <!-- <p class="c14"><span class="c8 c11 c10">TERMOS DA Planeje bem</span></p>
        <p class="c4"><span class="c8 c10 c11"></span></p>
        <p class="c4"><span class="c8 c11 c10"></span></p>
        <p class="c4"><span class="c8 c11 c10"></span></p> -->
      <h4 class="c11" id="h.lrmdog3rw6tr">
        <span class="c2 c7"
          >Termos, Condições de Uso e Política de Privacidade</span
        >
      </h4>
      <h5 class="c1 c12" id="h.xe1gx1kqjdiv">
        <span class="c0"></span>
      </h5>
      <h5 class="c1" id="h.ew4actq8suqq">
        <span class="c2"
          >Estes Termos e Condições de Uso (“Termos”) regem a utilização dos
          serviços oferecidos pela Planeje Bem Ltda., sociedade empresária
          limitada, inscrita no CNPJ/MF sob o nº 36.939.472/0001-51 (“Planeje
          Bem” ou “Empresa”) por meio do website
        </span>
        <span class="c2 c13">
          <a
            class="c6"
            href="https://www.google.com/url?q=http://www.planejebem.app&amp;sa=D&amp;source=editors&amp;ust=1728591531440591&amp;usg=AOvVaw3WPWwjDOFzMshG-36KfWJI"
            >www.planejebem.app
          </a>
        </span>
        <span class="c0"
          >, aplicativo específico (app), ou outras plataformas de comunicação
          com usuários, tais como WhatsApp, Facebook Messenger e outros
          (“Serviços” e “Plataforma”, respectivamente). O usuário de qualquer
          Serviço (“Usuário”) deve concordar com estes Termos previamente à sua
          utilização.</span
        >
      </h5>
      <h5 class="c1" id="h.pb4k4hmtszph">
        <span class="c0">
          Ao utilizar quaisquer Serviços fornecidos pela Planeje Bem, o Usuário
          declara que leu, compreendeu e concordou com estes Termos, inclusive
          com a política de privacidade da ‘l descrita nestes Termos (“Política
          de Privacidade”).
        </span>
      </h5>
      <h5 class="c1" id="h.qsomkyvqccmh">
        <span class="c0"
          >A Empresa recomenda que o Usuário leia com cuidado a integralidade
          deste e outros documentos aplicáveis aos Serviços disponibilizados
          pela Planeje Bem antes de utilizar os Serviços. Caso não concorde com
          alguma cláusula prevista em qualquer documento, o Usuário não está
          autorizado e não deverá utilizar os Serviços da Empresa. Estes Termos
          estarão disponíveis online para leitura a qualquer momento.</span
        >
      </h5>
      <h5 class="c1" id="h.aa0v72bk6hli">
        <span class="c0"
          >Com o intuito de garantir o constante aperfeiçoamento destes Termos e
          cumprimento da legislação e regulamentação aplicáveis, a Empresa se
          reserva o direito, a seu exclusivo critério e a qualquer tempo, de
          modificar estes Termos e suas políticas adjacentes, sem prévia
          comunicação, exceto em caso de vedação legal nesse sentido. A
          continuidade no uso dos Serviços após tais alterações constituirá o
          consentimento do Usuário em relação a todas as mudanças realizadas.
          Caso o Usuário não concorde com qualquer das alterações, o Usuário
          deverá se abster de utilizar os Serviços imediatamente, sem prejuízo
          do cumprimento das obrigações decorrentes dos Serviços contratados
          anteriormente que estejam em processo de execução.</span
        >
      </h5>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2">1. Condições de Acesso e Uso</span>
      </h5>
      <p class="c1" id="h.7bsqt8e3qga">
        <span class="c0"
          >1.1. Ao utilizar os Serviços, o Usuário declara expressamente que
          realizou a leitura completa destes Termos e manifesta sua concordância
          com relação às suas disposições. Por meio de tal ato, o Usuário
          manifesta sua aceitação livre e expressa, sem quaisquer reservas,
          acerca de todas as cláusulas destes Termos.</span
        >
      </p>
      <p class="c1" id="h.4lg4uu382w5u">
        <span class="c0"
          >1.2. Ao fazer o uso dos Serviços, o Usuário se compromete e se
          responsabiliza a fornecer, no momento do seu cadastro ou quando
          solicitado, dados e informações verídicas e completas. O Usuário
          garante a autenticidade de todos os dados informados,
          responsabilizando-se em âmbito civil e penal por quaisquer danos e/ou
          prejuízos eventualmente causados à Empresa ou a terceiros decorrentes
          do fornecimento de informações inexatas, incompletas ou
          inverídicas.</span
        >
      </p>
      <p class="c1" id="h.ilxcctzbkoqk">
        <span class="c0"
          >1.3. Ao usar os Serviços, o Usuário tem ciência de que as operações
          comerciais realizadas na Plataforma poderão ser objeto de validação
          automatizada e manual, bem como as informações poderão ser
          disponibilizadas para empresa especializada neste tipo de
          validação.</span
        >
      </p>
      <p class="c1" id="h.hubyigs1bwpq">
        <span class="c0"
          >1.4. O Usuário se compromete a manter todas as suas informações
          cadastrais permanentemente atualizadas.</span
        >
      </p>
      <p class="c1" id="h.e5zdm1o7poot">
        <span class="c0"
          >1.5. O Usuário está ciente que os documentos gerados pela Plataforma
          são automatizados. Portanto, é de sua inteira responsabilidade a
          inserção de informações adequadas, corretas, completas e sem potencial
          ofensivo a terceiros. Sendo vedado a inserção de conteúdo sigiloso
          como senhas ou informações que coloquem em risco a própria segurança
          ou de terceiros, uma vez que os documentos serão em algum momento
          publicizados e precisarão de assinaturas de outras pessoas.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >1.6. A Planeje Bem não presta serviços de assessoria ou consultoria
          jurídica, contábil, financeira, regulatória ou fiscal de qualquer
          outra natureza. Esta Empresa se limita a demonstrar estimativas
          baseadas nas informações inseridas pelo Usuário ao longo da Plataforma
          e na legislação vigente, a qual está sujeita a mutação interpretativa
          pelo decurso do tempo e especificidade do caso concreto. Portanto, não
          há qualquer responsabilidade entre os valores produzidos pela
          Plataforma e eventuais divergências com o caso concreto.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >1.7. A Plataforma não realiza tarefas de natureza burocrática ou
          administrativa, como abertura de inventários, assessoria jurídica,
          indicação de advogado, obtenção de certidões, registros (por exemplo,
          registro de óbito) ou liberações, além de qualquer serviço de
          assistência funeral (incluindo sepultamento, cremação ou remoção),
          exames cadavéricos, acompanhamento em bancos para recebimento de
          benefícios, entre outros.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >1.8. A Empresa poderá, a seu exclusivo critério, utilizar-se de todos
          os meios disponíveis, nos limites legais e regulatórios, para
          confirmar sua identidade e informações cadastrais. Caso necessário, a
          Empresa poderá solicitar dados adicionais e documentos que entenda
          pertinentes à confirmação e análise dos dados informados.</span
        >
      </p>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2">2. Declarações e Garantias</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >2.1. Ao utilizar os Serviços, o Usuário declara expressamente que tem
          plena capacidade, conforme definido pela legislação, para praticar
          atos da vida civil, incluindo a concordância com estes Termos e
          utilização dos Serviços. Não é permitida a utilização dos Serviços por
          menores de 18 (dezoito) anos (“Menores”).</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >2.2. A utilização dos Serviços é pessoal e exclusiva. O Usuário não
          pode permitir que terceiros utilizem sua conta na Plataforma, tampouco
          cedê-la ou transferi-la a qualquer terceiro. Os dados de acesso à
          Plataforma, incluindo senha, são pessoais e intransferíveis. O Usuário
          se responsabiliza de forma integral pela segurança e confidencialidade
          de seus dados de acesso à Plataforma, eximindo a Planeje Bem de
          qualquer responsabilidade decorrente de acesso indevido.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >2.3. Ao utilizar os Serviços, o Usuário concorda em cumprir com todas
          as leis brasileiras, bem como aquelas aplicáveis ao local em que está
          fisicamente presente durante a utilização dos Serviços que sejam
          eventualmente aplicáveis à Planeje Bem. O Usuário só pode acessar os
          Serviços por meio da Plataforma.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >2.4. É responsabilidade do Usuário verificar e garantir a utilização
          da Plataforma através do software correto para o seu dispositivo. A
          Empresa não se responsabiliza pela incompatibilidade do aparelho do
          Usuário com a Plataforma. A Empresa reserva o direito de realizar o
          desligamento do Usuário ou descontinuar os Serviços caso esteja usando
          os Serviços em um dispositivo incompatível, desatualizado ou não
          autorizado.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >2.5. Ao aceitar os presentes termos e utilizar os Serviços, o Usuário
          declara que:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) só fará uso dos Serviços para fins lícitos e previstos nestes
          Termos;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) não utilizará a Plataforma para enviar ou armazenar qualquer
          material ilegal ou para fins ilegais;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) não incluirá senhas de qualquer tipo na plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) está ciente de que não poderá utilizar qualquer material ou
          conteúdo que incorporem vírus ou outros elementos nocivos à
          Plataforma;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(v) não irá prejudicar o bom funcionamento dos Serviços de qualquer
          forma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vi) não irá copiar ou distribuir qualquer conteúdo sem a autorização
          por escrito da Empresa;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vii) utilizará os Serviços exclusivamente para fins pessoal, próprio
          e intransferível, sendo vedada a revenda a terceiros;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(viii) será unicamente responsável por manter de forma segura e
          confidencial a senha e qualquer outra identificação ou código que lhe
          permita o acesso aos Serviços; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) não se manifestará publicamente na Plataforma ou outro veículo
          de forma desrespeitosa, preconceituosa ou por meio de linguagem
          imprópria.</span
        >
      </p>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2"
          >3. Propriedade Intelectual, Concessão de Licenças e Restrições</span
        >
      </h5>
      <p class="c1">
        <span class="c0"
          >3.1. O Usuário tem ciência e concorda que todos os conteúdos e
          materiais apresentados pela Empresa, seja por meio da Plataforma ou
          não, tais como textos, ilustrações, imagens, vídeos, fotografias,
          bases de dados, aplicativos, arquivos, redes e quaisquer outras
          criações autorais e intelectuais (“Conteúdo”), são de propriedade
          exclusiva da Empresa ou de terceiros que autorizaram o uso por parte
          da Empresa.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >3.2. É expressamente proibido copiar, reproduzir, postar, publicar,
          republicar, realizar download, upload, modificar, traduzir,
          apresentar, distribuir, transmitir, realizar qualquer trabalho
          derivado ou de qualquer outra forma utilizar o Conteúdo de forma
          ilegal e/ou não autorizada, nos termos das leis e tratados
          internacionais aplicáveis. O desrespeito a essas regras sujeitará os
          infratores às sanções civis e criminais correspondentes, sem prejuízo
          de indenização por quaisquer perdas e danos à Planeje Bem.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >3.3. As disposições presentes nestes Termos não configuram um
          contrato de venda e não fornecem quaisquer direitos de propriedade
          relacionados à Plataforma e aos Serviços, assegurando a manutenção de
          quaisquer direitos de propriedade intelectual detidos pela Empresa. O
          nome da Empresa, o logotipo da Empresa, e os nomes de produtos
          associados aos Serviços são marcas comerciais da Empresa ou de
          terceiros, sendo vedada sua utilização não autorizada para quaisquer
          fins.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >3.4. É concedida ao Usuário uma licença não exclusiva e
          intransferível de direito de uso da Plataforma, limitando-se a fins
          pessoais (não comerciais). Todos os direitos não expressamente
          concedidos ao Usuário são reservados à Empresa.
        </span>
      </p>
      <p class="c1">
        <span class="c0">3.5. É expressamente vedado:</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(i) licenciar, sublicenciar, vender, revender, transferir, ceder,
          distribuir, explorar comercialmente ou disponibilizar a terceiros os
          Serviços de qualquer forma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) modificar ou realizar serviços derivados com base nos Serviços
          aqui previstos; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) criar “links” virtuais para o Serviço ou “frame” ou “espelho”
          da Plataforma em qualquer outro servidor ou dispositivo.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >3.6. Em caso de qualquer suspeita e/ou constatação de ilicitude, a
          Empresa se reserva o direito de suspender ou cancelar o acesso do
          Usuário à Plataforma e aos Serviços, bem como tomar as medidas legais
          cabíveis, incluindo, mas não se limitando a ações civis e criminais de
          reparação de danos. Mesmo após a suspensão ou o cancelamento do
          direito do Usuário de utilizar os Serviços, estes Termos continuarão
          válidos, aplicáveis e vinculantes ao Usuário, conforme aplicável, até
          que todas as obrigações presentes nestes Termos e demais políticas
          aplicáveis sejam adimplidas.
        </span>
      </p>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2">4. Tratamento de Dados Pessoais</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >4.1. O Usuário autoriza expressamente o tratamento de seus dados
          pessoais, fornecidos e compartilhados no cadastro e na utilização da
          Plataforma, com a finalidade de prestar os Serviços adequadamente,
          cumprir obrigações legais e contratuais, apresentar ofertas e
          propagandas compatíveis com o perfil do Usuário e customizar a oferta
          de produtos e Serviços, sempre nos termos da legislação e
          regulamentação vigentes. Tais dados pessoais incluem nome, documentos
          pessoais, e-mail, endereço e hábitos de utilização e aquisição de
          produtos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.2. A Planeje Bem se reserva o direito de compartilhar, reservados
          os direitos do Usuário, informações obtidas por meio de cookies e
          dados não qualificados como pessoais, nos termos da legislação e
          regulamentação aplicáveis, com terceiros parceiros para os fins
          representados, mas não limitados, de:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) prestação dos Serviços e outros associados à utilização da
          Plataforma;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) proteção dos interesses da Empresa, em conflitos judiciais e
          extrajudiciais;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) transações ou alterações societárias da Empresa;</span
        >
      </p>
      <p class="c1">
        <span class="c0">(iv) desenvolvimento de produtos e serviços; </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(v) oferta de produtos e serviços voltados para os interesses do
          Usuário; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vi) geração de dados estatísticos acerca do uso dos Serviços.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.3. Obrigações, direitos e informações adicionais referentes ao
          tratamento de dados pessoais estão presentes na seção “Política de
          Privacidade” destes Termos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.4. A Planeje Bem assegura a observância e o cumprimento dos
          direitos do Usuário em relação aos seus dados pessoais, conforme
          legislação e regulamentação aplicável. Nos termos da Lei Geral de
          Proteção de Dados (“LGPD”), o Usuário tem o direito de acessar,
          corrigir, portar, eliminar seus dados, além de confirmar que tratamos
          de seus dados. Em determinadas circunstâncias, o Usuário também tem o
          direito de se opor e restringir o tratamento de seus dados pessoais.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >4.5. Para ter acesso à Plataforma, o Usuário deverá realizar o
          cadastro e possuir uma apólice ativa que tenha acesso aos recursos
          disponibilizados por meio de um Parceiro da Planeje Bem. Durante o
          processo de cadastro, serão solicitados o CPF e a data de nascimento
          do Usuário para validação da apólice, seguidos da inserção de um
          e-mail pessoal. Após a confirmação do e-mail, o Usuário deverá
          manifestar ciência e concordância com estes Termos, Condições de Uso e
          Política de Privacidade.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.5.1. O Usuário garante a veracidade e atualização das informações
          prestadas, sendo o único responsável pelas atividades realizadas em
          sua conta. É de sua responsabilidade comunicar imediatamente qualquer
          uso não autorizado ou suspeita de violação de segurança. A conta é de
          uso pessoal, individual e intransferível.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.5.2. A depender do recurso habilitado na Plataforma, poderão ser
          solicitados dados pessoais adicionais, tanto do usuário quanto de
          entes queridos falecidos, com o objetivo de prestar suporte
          personalizado. Tais dados podem incluir, mas não se limitam a: nome
          completo, data de nascimento, CPF, estado civil, número de documento,
          endereço de residência, estado de residência, propriedades e ativos,
          dados de parentes, relacionamento com o ente querido falecido, data do
          óbito, estado civil e regime de trabalho.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.6. O tratamento de dados pessoais realizado pela Planeje Bem
          observa as hipóteses legais previstas nos Artigos 7º e 11 da Lei Geral
          de Proteção de Dados Pessoais (Lei nº 13.709/2018). Conforme o Art.
          7º, os dados pessoais dos usuários poderão ser tratados nas seguintes
          hipóteses, dentre outras: mediante consentimento do titular, para
          cumprimento de obrigação legal ou regulatória, para a execução de
          contrato ou de procedimentos preliminares relacionados a contrato do
          qual seja parte o titular, e para o exercício regular de direitos em
          processo judicial, administrativo ou arbitral.</span
        ><br /><br />

        <span class="c0"
          >Nos casos em que forem tratados dados pessoais sensíveis (como, por
          exemplo, dados relacionados à vida familiar ou estado de saúde do ente
          querido falecido), a Planeje Bem observará as bases legais do Art. 11
          da LGPD, tratando tais dados mediante consentimento específico e
          destacado do titular ou quando necessário para o exercício regular de
          direitos, inclusive em contrato ou processo judicial, administrativo
          ou arbitral.</span
        ><br /><br />

        <span class="c0"
          >Os dados serão utilizados exclusivamente para as finalidades
          descritas neste Termo, tais como: verificação de elegibilidade à
          plataforma, personalização do atendimento, cumprimento de obrigações
          legais, estatísticas e segurança.</span
        ><br /><br />

        <span class="c0"
          >A Planeje Bem adota medidas técnicas e administrativas para proteger
          os dados pessoais contra acessos não autorizados, destruição, perda,
          alteração, comunicação ou difusão.</span
        ><br /><br />

        <span class="c0"
          >O compartilhamento de dados com Parceiros contratados será realizado
          apenas quando necessário para a prestação dos serviços e com o devido
          respaldo legal.</span
        ><br /><br />

        <span class="c0">
          O Usuário poderá solicitar informações adicionais sobre o tratamento
          de seus dados, bem como exercer seus direitos previstos na LGPD, por
          meio dos canais de contato disponíveis na Plataforma. </span
        ><br />
      </p>
      <p class="c1">
        <span class="c0"
          >4.7 Os dados pessoais serão armazenados pelo tempo necessário para o
          cumprimento das finalidades para as quais foram coletados, observando
          os prazos legais aplicáveis, ou enquanto durar a relação entre o
          usuário e a Plataforma.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.8. A Planeje Bem poderá armazenar dados pessoais em servidores
          localizados fora do Brasil, inclusive por meio de serviços em nuvem,
          assegurando que tais transferências ocorram em conformidade com a
          LGPD, mediante adoção de mecanismos legais adequados para garantir o
          mesmo nível de proteção exigido pela legislação brasileira.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.9. A Planeje Bem poderá utilizar dados anonimizados para análises
          estatísticas, estudos de melhoria contínua dos serviços e elaboração
          de relatórios. Dados anonimizados não permitem a identificação direta
          ou indireta do titular e poderão ser mantidos por prazo
          indeterminado.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >4.10. Nos casos em que o Usuário deixar de ter apólice ativa, seja
          por cancelamento ou inadimplência, a Planeje Bem poderá, após período
          de inatividade, eliminar os dados pessoais da conta, exceto quando
          houver necessidade de manutenção para cumprimento de obrigação legal
          ou regulatória, defesa de direitos em processo judicial,
          administrativo ou arbitral, ou interesse legítimo devidamente
          fundamentado.</span
        >
      </p>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2">5. Política de Privacidade</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >5.1. Esta Seção informa sobre a política da Empresa relativas à
          coleta, uso, divulgação e armazenamento de dados pessoais dos Usuários
          da Plataforma, bem como sobre as opções que os Usuários possuem em
          relação a estes dados.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >5.2. A Empresa utiliza os dados dos Usuários para fornecer e melhorar
          a Plataforma e, ao usá-la, o Usuário concorda com a coleta e uso de
          suas informações nos termos desta Política de Privacidade.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >5.3. Para os fins desta Seção, os seguintes termos pré-definidos
          serão utilizados:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) “Dados Pessoais” significa dados de um indivíduo em plena
          capacidade e que sejam capazes de identificá-lo;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) “Dados de Uso” são dados coletados automaticamente, gerados pelo
          uso da Plataforma ou da própria infraestrutura da Plataforma (por
          exemplo, a duração de uma visita à Plataforma);
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) “Cookies” são pequenos arquivos armazenados no dispositivo do
          Usuário (computador ou dispositivo móvel);
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) “Controlador de Dados” significa a pessoa física ou jurídica que
          (isoladamente ou em conjunto com outras pessoas) determina os fins
          para os quais, e a maneira pela qual, qualquer informação pessoal é ou
          deve ser processada. Para os fins desta Seção, a Empresa é um
          Controlador de Dados dos Dados Pessoais dos Usuários; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(v) “Processador de Dados” ou “Provedor de Serviço” significa
          qualquer pessoa física ou jurídica que processe os dados em nome do
          Controlador de Dados. Neste sentido, a Empresa poderá usar os serviços
          de vários Provedores de Serviços para processar os dados dos Usuários
          com mais eficiência.5.4. Coleta e Uso de Informações. Ao usar a
          Plataforma, a Empresa poderá solicitar que o Usuário nos forneça
          alguns Dados Pessoais, que podem ser usados para contatá-lo ou
          identificá-lo. Dentre as informações pessoalmente identificáveis,
          podem estar incluídas, a título de exemplo não exaustivo:</span
        >
      </p>
      <p class="c1">
        <span class="c0">(i) endereço de e-mail;</span>
      </p>
      <p class="c1">
        <span class="c0">(ii) nome e sobrenome;</span>
      </p>
      <p class="c1">
        <span class="c0">(iii) número de telefone;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) endereço, estado, província, código postal, cidade; e</span
        >
      </p>
      <p class="c1">
        <span class="c0">(v) Cookies e Dados de Uso.</span>
      </p>
      <p class="c1">
        <span class="c0"
          >5.4.1. A Empresa poderá usar, ainda, os Dados Pessoais do Usuário
          para contatá-lo com boletins informativos, materiais de marketing ou
          promocionais e outras informações que possam ser de seu interesse. O
          Usuário pode optar por não receber nenhuma ou todas essas
          comunicações, seguindo o link de cancelamento de inscrição ou as
          instruções fornecidas em qualquer e-mail enviado pela Empresa.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.5. Dados de Uso. A Empresa poderá, também, coletar Dados de Uso,
          que podem incluir informações como o endereço IP do computador do
          Usuário, tipo de navegador, versão do navegador, as páginas da
          Plataforma que o Usuário visita, a hora e data de sua visita, o tempo
          gasto nestas páginas e outros dados de diagnóstico.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >5.6. Rastreamento e Dados de Cookies. A Empresa utiliza Cookies e
          tecnologias de rastreamento semelhantes para rastrear a atividade em
          nossa Plataforma e retermos certas informações. .</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.6.1. Cookies são arquivos com uma pequena quantidade de dados que
          podem incluir um identificador exclusivo anônimo. Os Cookies são
          enviados para o seu navegador a partir de um site e armazenados no seu
          dispositivo. Outras tecnologias de rastreamento também são usadas,
          como beacons, tags e scripts para coletar e rastrear informações, bem
          como para melhorar e analisar nossa Plataforma.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >5.6.2. O Usuário poderá instruir seu navegador para recusar todos os
          Cookies ou para indicar quando um Cookie está sendo enviado. No
          entanto, se o Usuário não aceitar Cookies, talvez não consiga usar
          algumas partes da Plataforma.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.6.3. Exemplos de Cookies utilizados pela Plataforma:</span
        >
      </p>
      <p class="c1">
        <span class="c0">(i) Cookies de sessão, para operar os Serviços;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) Cookies preferenciais, para lembrar as preferências e várias
          configurações dos Usuários; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) Cookies de segurança, para fins de segurança.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.7. Uso de Dados. A Empresa usa os dados coletados para diversos
          fins, dos quais pode-se destacar, a título exemplificativo:</span
        >
      </p>
      <p class="c1">
        <span class="c0">(i) para disponibilizar e manter a Plataforma;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) para notificar o Usuário sobre alterações na Plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) para permitir que o Usuário participe de recursos interativos
          da Plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0">(iv) para fornecer suporte ao Usuário;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(v) para reunir análises ou informações valiosas para melhorar a
          Plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0">(vi) para monitorar o uso da Plataforma;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(vii) para detectar, prevenir e resolver problemas técnicos; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(viii) para fornecer ao Usuário notícias, ofertas especiais e
          informações gerais sobre outros bens, serviços e eventos ofertados na
          Plataforma que sejam semelhantes àqueles que o respectivo Usuário já
          tenha comprado ou pesquisado, a menos que tenha optado por não receber
          tais informações.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.8. Retenção de Dados. A Empresa poderá reter os Dados Pessoais dos
          Usuários apenas pelo tempo que for necessário para os propósitos
          estabelecidos nesta Seção, por no máximo 3 anos. A Empresa reterá e
          usará os Dados Pessoais na medida em que seja necessário para cumprir
          com suas obrigações legais, resolver disputas e fazer cumprir os
          contratos e políticas legais.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.8.1. A Empresa também reterá Dados de Uso para fins de análise
          interna. Os Dados de Uso são geralmente retidos por um curto período
          de tempo, à exceção dos casos nos quais esses dados estiverem sendo
          usados para fortalecer a segurança ou para melhorar a funcionalidade
          da Plataforma, ou de quando a Empresa for legalmente obrigada a reter
          esses dados por períodos mais longos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.9. Transferência de Dados. As informações do Usuário, incluindo
          Dados Pessoais, podem ser transferidas para – e mantidas em –
          computadores localizados fora do seu estado, província, país ou de sua
          jurisdição governamental, onde as leis de proteção de dados podem
          diferir.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.9.1. O consentimento em relação aos termos destes Termo, seguido
          pelo envio das informações referidas nesta Seção, representa a
          concordância com a transferência mencionada nesta Seção.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.9.2. A Empresa tomará todas as medidas razoavelmente cabíveis para
          garantir que os dados dos Usuários sejam tratados com segurança e de
          acordo com esta Seção, bem como para que nenhuma transferência dos
          Dados Pessoais do Usuário ocorra para uma organização ou país, a menos
          que ofereçam controles adequados em vigor.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.10. Divulgação de Dados. Se a Empresa estiver envolvida em uma
          fusão, aquisição ou venda de ativos, os Dados Pessoais poderão ser
          transferidos. Não obstante, nesse cenário, a Empresa fornecerá um
          aviso antes que os Dados Pessoais sejam efetivamente transferidos e se
          tornem sujeitos a uma Política de Privacidade diferente.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.10.1. Sob certas circunstâncias, a Empresa pode ser solicitada a
          divulgar Dados Pessoais, caso assim seja exigido por lei ou por
          solicitações válidas de autoridades públicas.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.10.2. A Empresa pode, munida de boa-fé, divulgar os Dados Pessoais,
          desde que entenda assim ser necessário para:</span
        >
      </p>
      <p class="c1">
        <span class="c0">(i) cumprir uma obrigação legal;</span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) proteger e defender os direitos ou propriedade da Empresa;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) evitar ou investigar possíveis irregularidades relacionadas ao
          Serviço;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) proteger a segurança pessoal dos Usuários; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(v) proteger-se contra responsabilidade legal que, eventualmente,
          venha a ser imputada.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.11. Segurança de Dados. A segurança dos dados dos Usuários é
          importante para a Empresa, mas o Usuário deve lembrar-se de que nenhum
          método de transmissão pela internet ou de armazenamento eletrônico é
          100% (cem por cento) seguro. Fica expresso, no entanto, que a Empresa
          se compromete a envidar seus melhores esforços para proteger os Dados
          Pessoais, de modo que a Empresa usará os meios comercialmente
          aceitáveis para tanto.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.12 Direitos de proteção de dados sob o LGPD. O Usuário tem certos
          direitos de proteção de dados específicos que são elencados no LGPD. A
          Empresa objetiva tomar todas as medidas que forem economicamente
          razoáveis para permitir que o Usuário corrija, altere, elimine ou
          limite o uso de seus Dados Pessoais.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.12.1. Se o Usuário desejar ser informado sobre quais de seus Dados
          Pessoais serão mantidos, ou se desejar que sejam removidos dos
          sistemas da Empresa, o respectivo Usuário deverá entrar em contato com
          a Empresa com solicitação específica nesse sentido.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.12.2. Em determinadas circunstâncias, os Usuários têm os seguintes
          direitos de proteção de dados:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) Direito de acessar, atualizar ou excluir as informações. Sempre
          que possível, o Usuário poderá acessar, atualizar ou solicitar a
          exclusão de seus dados pessoais diretamente na seção de configurações
          da sua conta. Se o Usuário não puder realizar essas ações sozinho,
          deverá entrar em contato com a Empresa;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) Direito de retificação. O Usuário tem o direito de retificar
          suas informações, caso estas informações estejam imprecisas ou
          incompletas;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) Direito de objeção. O Usuário tem o direito de se opor ao
          processamento de seus dados pessoais;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) Direito de restrição. O Usuário tem o direito de solicitar que a
          Empresa restrinja o processamento de suas informações pessoais;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(v) Direito à portabilidade de dados. O Usuário tem o direito de
          receber uma cópia das informações que a Empresa possui sobre ele em um
          formato estruturado, legível por máquina e comumente utilizado;
          e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vi) Direito de retirar o consentimento. O Usuário também tem o
          direito de retirar seu consentimento a qualquer momento, nos casos em
          que seu consentimento era necessário para processar suas informações
          pessoais.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.12.3. O Usuário deve se atentar para o fato de que a Empresa pode
          pedir-lhe para confirmar a sua identidade antes de responder a esses
          pedidos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.12.4. O Usuário tem o direito de reclamar com uma autoridade de
          proteção de dados sobre a coleta e uso de seus Dados Pessoais.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.13. Provedores de Serviço. A Empresa poderá contratar empresas
          terceirizadas e indivíduos para facilitar a atividade da Empresa,
          realizá-la em seu nome, executar serviços relacionados à Plataforma ou
          auxiliar a Empresa na análise de como a Plataforma é utilizada.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.13.1 Esses terceiros têm acesso aos Dados Pessoais apenas para
          realizar as tarefas que tiverem sido designados para realizar em nome
          da Empresa, e são obrigados a não divulgá-los ou usá-los para qualquer
          outra finalidade.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.14. Análise de dados. A Empresa poderá usar Provedores de Serviço
          terceirizados para monitorar e analisar o uso de nossa Plataforma,
          tais como Google Analytics e Mixpanel.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.15. Links para Outros Sites. A Plataforma pode conter links para
          outros sites que não são operados pela Empresa. Se o Usuário clicar em
          um link de terceiros, ele será direcionado para outro site. Sendo
          assim, recomenda-se que o Usuário se atente à política de privacidade
          de todos os sites que visita.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.15.1. A Empresa não tem controle e não assume qualquer
          responsabilidade pelo conteúdo, políticas de privacidade ou práticas
          de quaisquer sites ou serviços de terceiros.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >5.16. Privacidade das Crianças. A Empresa não coleta intencionalmente
          informações de identificação pessoal de menores de idade. Pais, mães
          ou responsáveis legais que estejam cientes de que um menor de idade
          sob sua responsabilidade forneceu dados pessoais à Empresa, deverão
          entrar em contato com a Empresa. Se a Empresa ficar ciente de que foi
          coletado Dados Pessoais de Menores de Idade sem a verificação do
          consentimento dos responsáveis, a Empresa tomará medidas para remover
          essas informações de seus servidores.</span
        >
      </p>
      <h5 class="c1" id="h.ttaq008mjt8k">
        <span class="c5 c2">6. Isenção de Garantias</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >6.1. Sem prejuízo das demais disposições previstas nestes Termos, não
          é garantido pela Empresa que:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) o uso da Plataforma será sempre seguro, oportuno, ininterrupto,
          sem erros ou funcionará em combinação com qualquer outro
          sistema;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) entregará mensagens, vídeos e/ou correspondências a
          destinatários designados pelo Usuário, dentro dos prazos e formas
          designadas;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) os Serviços atenderão sempre as necessidades ou expectativas do
          Usuário;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) a validade jurídica dos Serviços será reconhecida pelo
          judiciário;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(v) erros ou defeitos na Plataforma, inclusive relacionados a
          informações sobre produtos e Serviços, serão corrigidos imediatamente;
          e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vi) a Plataforma estará livre de vírus ou outros componentes nocivos
          permanentemente.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >6.2. A Empresa não possui qualquer garantia referente a problemas de
          conexão à internet. Assim, Serviços da Empresa podem estar sujeitos às
          limitações, atrasos e outros problemas relacionados à conexão de
          internet, servidores, redes e demais componentes relacionados a
          infraestrutura eletrônica e virtual. A Empresa não se responsabiliza
          pela impossibilidade ou dificuldade de utilização dos Serviços,
          quaisquer atrasos, falhas ou quaisquer danos resultantes de tais
          problemas.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >6.3. A Empresa se compromete a envidar os melhores esforços para
          disponibilizar os Serviços com qualidade, a partir de altos padrões
          técnicos para as atividades desempenhadas.</span
        >
      </p>
      <h5 class="c1" id="h.xcuaugynlz5f">
        <span class="c5 c2">7. Limitações de Responsabilidade</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >7.1. O Usuário está ciente e concorda que a Empresa, sem prejuízo das
          demais cláusulas destes Termos, não se responsabiliza:</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(i) por quaisquer problemas ou funcionamento inadequado de
          dispositivos e equipamentos de terceiros, mesmo que relacionados ao
          uso regular da Plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(ii) por eventos relacionados ou ações e/ou omissões de terceiros,
          como ataques cibernéticos, falhas em sistemas, no servidor ou na
          conexão à internet, ações ou omissões de entregadores terceirizados,
          entre outros;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(iii) pela instabilidade e/ou não funcionamento da Plataforma,
          independentemente do motivo;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(iv) por erros incontingência no sistema que alterem a apresentação
          de dados, características ou informações de produtos;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(v) por falhas na entrega de mensagens, vídeos e/ou correspondências
          enviadas pelo Usuários a terceiros;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vi) por eventuais informações incompletas, imprecisas ou
          desatualizadas disponibilizadas por terceiros na Plataforma;</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(vii) pelo acesso de terceiros à conta do Usuário, sobretudo se
          decorrente de utilização de dados de acesso do Usuário de forma
          inadequada e/ou em desconformidade com estes Termos;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(viii) pelas minutas geradas pela plataforma, uma vez que não são
          arquivadas pela Planeje Bem;
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >(ix) pela promoção de serviços de consultoria jurídica demandados
          pelo Usuário; e</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >(x) pela prestação de Serviços a Usuário em desconformidade com estes
          Termos ou quaisquer políticas da Planeje Bem.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.2. Ao utilizar os Serviços, o Usuário reconhece que é o único
          responsável pelo uso da sua conta na Plataforma. O Usuário é
          responsável por manter a confidencialidade de qualquer senha ou dado
          provido à Empresa para utilizar os Serviços. O Usuário é o único
          responsável por atividades realizadas em sua conta, incluindo compras
          e/ou outras atividades decorrentes de acessos indevidos por terceiros.
          Caso haja suspeitas de que uma pessoa não autorizada está utilizando
          sua conta, o Usuário deve notificar a Empresa imediatamente e alterar
          os dados de acesso, se possível.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.3. É reservado à Empresa o direito de remover, a seu exclusivo
          critério, qualquer conteúdo inserido pelo Usuário que a Empresa
          considere ser contrário ao disposto na legislação e/ou nestes Termos,
          bem como que tenham conteúdo impróprio, chulo, ofensivo,
          preconceituoso, rude, obsceno ou de baixo calão, sem que seja devida
          qualquer forma de ressarcimento ao Usuário.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.4. A Planeje Bem tem como objetivo fornecer informações úteis e
          esclarecedoras aos Usuários por meio de sua Plataforma. No entanto,
          essas informações não devem ser interpretadas como orientações
          personalizadas para casos específicos. O conteúdo disponibilizado na
          plataforma tem caráter exclusivamente informativo e educativo, não
          configurando, em nenhuma hipótese, uma consultoria profissional. Dessa
          forma, recomendamos fortemente que, para questões mais complexas ou
          sensíveis, o usuário busque o auxílio de profissionais especializados.
        </span>
      </p>
      <p class="c1">
        <span class="c0"
          >7.5. A Empresa não se responsabiliza por quaisquer danos, sejam eles
          diretos, indiretos, eventuais ou de qualquer outra natureza. Essa
          limitação de responsabilidade abrange todos os aspectos relacionados
          ao uso da Plataforma Planeje Bem, incluindo o acesso ao conteúdo,
          produtos ou serviços disponibilizados. Além disso, a Planeje Bem não
          se responsabiliza por decisões ou ações tomadas pelo Usuário com base
          no uso da Plataforma, nem garante que todas as necessidades ou
          expectativas do Usuário serão plenamente atendidas.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.6. A plataforma não assume a responsabilidade por pagamentos
          relacionados a documentos ou processos burocráticos. A plataforma não
          se responsabilizará por coletar informações de órgãos e
          estabelecimentos em relação às dúvidas solicitadas.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.7. A Planeje Bem não se responsabiliza por danos de qualquer
          natureza relacionados ao uso da Plataforma, incluindo conteúdos
          oferecidos. Informações, prazos e alertas fornecidos pela Plataforma
          são meramente informativos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.8. A Planeje Bem não se responsabiliza por ações, omissões ou
          decisões tomadas por terceiros com base em informações
          disponibilizadas por meio da Plataforma. Isso inclui, mas não se
          limita, a pessoas indicadas pelo Usuário, como guardiões ou outros
          contatos.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.9. O Usuário é integralmente responsável pela inserção, atualização
          e precisão das informações fornecidas na Plataforma, incluindo dados
          de terceiros. A Planeje Bem não garante a efetividade ou continuidade
          de qualquer funcionalidade dependente dessas informações.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.10. A Plataforma atua como intermediadora de informações e
          comunicações, não assumindo qualquer responsabilidade pelo uso que
          terceiros façam dos dados recebidos ou pela ausência de resposta de
          contatos cadastrados pelo Usuário.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >7.11. A Planeje Bem se reserva o direito de limitar, suspender ou
          encerrar funcionalidades da Plataforma, a qualquer momento e sem aviso
          prévio, quando entender necessário para preservar sua operação ou
          segurança.</span
        >
      </p>
      <h5 class="c1">
        <span class="c5 c2">8. Comunicação com a Empresa</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >8.1. Serão consideradas válidas todas as comunicações realizadas à
          Empresa quando direcionadas aos seguintes canais de comunicação
          oficiais: (i) chat disponível dentro da Plataforma, após sua
          disponibilização; (ii) e-mail
          <a class="c6" href="mailto:contato@planejebem.app"
            >contato@planejebem.app</a
          >.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >8.2. Serão consideradas recebidas todas as comunicações realizadas
          pela Empresa ao Usuário por meio dos endereços cadastrados no sistema
          da Empresa. A Empresa não se responsabiliza pela incorreção ou
          desatualização dos dados cadastrais do Usuário, o qual tem o dever de
          mantê-los sempre corretos e atualizados.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >8.3. Nossos atendentes se limitam a esclarecer dúvidas sobre tarefas
          da plataforma, não fazemos consultoria jurídica, contábil, financeira,
          regulatória ou fiscal.</span
        >
      </p>
      <h5 class="c1">
        <span class="c5 c2">9. Término do Contrato</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >9.1. Estes Termos entram em vigor na data de início da utilização da
          Plataforma ou dos Serviços. É reservado ao Usuário ou à Empresa o
          direito de rescindir a relação contratual e encerrar a utilização do
          Serviço a qualquer momento, por qualquer motivo.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >9.2. Observada a legislação aplicável, a Empresa pode proibir o uso
          dos Serviços pelo Usuário a qualquer momento, a seu exclusivo
          critério, independentemente de prévio aviso, não sendo devido qualquer
          tipo de indenização ao Usuário em razão disso.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >9.3. A rescisão destes Termos é realizada de forma concomitante à
          exclusão da conta de acesso do Usuário à Plataforma.</span
        >
      </p>
      <h5 class="c1">
        <span class="c5 c2">10. Disposições Finais</span>
      </h5>
      <p class="c1">
        <span class="c0"
          >10.1. Não se pretende criar pela Empresa, em nenhuma hipótese,
          relação de parceria, emprego, trabalho, join venture, franquia,
          sociedade ou outras que excedam uma simples transação comercial de
          compra e venda entre comprador (Usuário) e vendedor (Empresa)
          relacionada à utilização dos Serviços e da Plataforma disponibilizada
          ao Usuário.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >10.2. Estes Termos são regidos exclusivamente pelas leis
          brasileiras.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >10.3. Qualquer cláusula ou condição destes Termos que, por qualquer
          razão, seja considerada inválida, nula ou ineficaz por uma jurisdição
          competente, não afetará a validade das demais cláusulas presentes nos
          Termos, os quais permanecerão plenamente válidos e vinculantes, com
          força e efeito legal.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >10.4. Caso a Empresa deixe de exigir quaisquer direitos ou
          disposições destes Termos, isso não constituirá renúncia, podendo
          exercê-los regularmente dentro dos prazos legais.</span
        >
      </p>
      <p class="c1">
        <span class="c0"
          >10.5. Fica eleito o Foro do Município de São Paulo para a resolução
          de qualquer litígio resultante da interpretação ou execução dos
          presentes Termos, renunciando as partes a qualquer outro, por mais
          privilegiado que seja.</span
        >
      </p>
      <p class="c1"><span class="c0"></span></p>
      <p class="c1"><span class="c0"></span></p>
    </div>
  </div>
  <div
    class="d-flex align-items-center justify-content-between mt-5 w-100 px-6 px-lg-15 pb-5 action-bar"
  >
    <button class="bl-back back-button-terms" (click)="logout()">VOLTAR</button>
    <button class="btn btn-primary add-button" (click)="updateTermsUser()">
      <div
        *ngIf="isLoading | async"
        class="spinner spinner-secondary mr-10"
      ></div>
      ACEITAR E CONTINUAR
    </button>
  </div>
</ng-template>
